import type { Translation } from '../../types/i18n'

export const es: Translation = {
  announcement:
    'Hechos sobre pedido · 3 días de anticipación · Mínimo 50 $ · Recogida en Chambly o entrega',
  nav: {
    home: 'Inicio',
    cacao: 'El Arte del Cacao',
    creations: 'Nuestras Creaciones',
    ingredients: 'Ingredientes',
    giftCard: 'Tarjeta regalo',
    recipes: 'Recetas',
    events: 'Corporativo y Eventos',
    contact: 'Contacto',
    cart: 'Carrito',
    order: 'Pedir',
  },
  hero: {
    eyebrow: 'Chocolatería artesanal · Chambly',
    titleLead: 'Les Artisans Sucrés',
    titleAccent: 'El Arte del Cacao',
    subtitle:
      'Cacao con carácter, creaciones elegantes y una historia de resiliencia y pasión.',
    ctaPrimary: 'Descubrir creaciones',
    ctaSecondary: 'El Arte del Cacao',
  },
  cacao: {
    eyebrow: 'Nuestra filosofía',
    titleLead: 'El Arte del',
    titleAccent: 'Cacao',
    intro:
      'El cacao es mucho más que un ingrediente: es un legado vivo, un fruto sagrado que las civilizaciones antiguas consideraban un tesoro. Cada haba lleva una historia, una energía y una nobleza que honramos con respeto y delicadeza.',
    benefitsTitle:
      'Antes de convertirse en chocolate, el cacao es un alimento poderoso',
    benefits: [
      'Rico en antioxidantes',
      'Beneficioso para el corazón',
      'Elevador natural del ánimo',
      'Fuente de minerales esenciales',
      'Favorece la memoria y la concentración',
    ],
    philosophyTitle: 'Nuestro credo',
    philosophyQuote: 'Menos azúcar, más cacao.',
    philosophyText:
      'Cuanto mayor es el porcentaje de cacao, más auténtico, nutritivo y lleno de sabor real es el chocolate. Nuestras creaciones están pensadas para ser sanas, refinadas y profundamente verdaderas.',
    heritageTitle: 'Un homenaje a nuestras raíces',
    heritageText:
      'Los alfajores peruanos — clásicos o bañados en chocolate de calidad — son un homenaje a sus raíces. Una alianza entre tradición y modernidad, hecha a mano, con intención, precisión y amor.',
  },
  promo: {
    badge: 'Oferta de bienvenida',
    title:
      'Únete ahora y recibe un 15 % de descuento en tu primer pedido en línea.',
    text: 'Y desbloquea más descuentos, recetas y delicias chocolateras exclusivas.',
    placeholder: 'Tu correo electrónico',
    cta: 'Quiero unirme',
    success: '¡Gracias! Tu código del 15 % llega por correo.',
  },
  story: {
    eyebrow: 'Mi historia',
    titleLead: 'Una pasión por el',
    titleAccent: 'chocolate verdadero',
    strugglesIntro: 'Mis comienzos no fueron fáciles:',
    struggles: [
      'El chocolate se negaba a templarse',
      'Los moldes no se desmoldaban',
      'Los colorantes se quedaban pegados',
    ],
    paragraphs: [
      'Pero nunca me detuve. Practiqué, fracasé, volví a empezar… una y otra vez. Mi filosofía es clara: ningún obstáculo puede detener la pasión, la disciplina y el deseo de alcanzar la perfección.',
      'Hoy creo chocolates únicos, elegantes y llenos de emoción. En Les Artisans Sucrés trabajamos chocolates de alto porcentaje para ofrecer productos más sanos, más auténticos y ricos en sabor real.',
      'También ofrecemos nuestros alfajores peruanos clásicos y bañados en chocolate de calidad, un homenaje a mis raíces, revisitado con un toque moderno y refinado.',
      'Les Artisans Sucrés es la expresión de mi historia, de mi resiliencia y de mi amor profundo por el arte del cacao.',
    ],
    closing:
      'Cada producto está hecho a mano, con intención, precisión y amor.',
    signatureName: 'Sara',
    signatureRole: 'Maestra Chocolatera',
  },
  products: {
    eyebrow: 'Nuestras Colecciones',
    titleLead: 'Creaciones',
    titleAccent: 'Deliciosas',
    addToCart: 'Añadir al carrito',
    added: '¡Añadido!',
    quantity: 'Cantidad',
    chooseOption: 'Elige tu formato',
    saveForLater: 'Guardar para después',
    savedLabel: 'Guardado',
    orderNow: 'Pasar el pedido',
    from: 'desde',
    categoriesLabel: 'Categorías',
    categories: [
      { id: 'all', name: 'Ver todo' },
      { id: 'alfajores', name: 'Alfajores' },
      { id: 'chocolats', name: 'Chocolates finos' },
      { id: 'tablettes', name: 'Tabletas' },
      { id: 'croustillants', name: 'Crujientes' },
      { id: 'cakepops', name: 'Cake pops' },
    ],
    items: [
      {
        id: 'alfajores',
        name: 'Alfajores Peruanos',
        subtitle: 'Nuestra Firma',
        description:
          'Dos galletas suaves que abrazan un corazón generoso de dulce de leche artesanal y mermelada de fresa casera, espolvoreados con azúcar glas. Un homenaje a mis raíces peruanas, en cajas de 12 a 60.',
        tags: ['Dulce de leche', 'Mermelada de fresa', '12 a 60'],
      },
      {
        id: 'alfajores-enrobes',
        name: 'Alfajores Bañados en Chocolate',
        subtitle: 'Tradición y Cacao',
        description:
          'Nuestros alfajores peruanos completamente bañados en chocolate de calidad — negro 70 %, blanco o con leche — y decorados con almendras, pecanas o arándanos. La caja de 12.',
        tags: ['Negro 70 %', 'Blanco', 'Con leche'],
      },
      {
        id: 'bonbons',
        name: 'Chocolates Pralinés',
        subtitle: 'La Elegancia del Cacao',
        description:
          'Bombones pralinés pintados a mano, de cáscara fina y corazón sedoso. Envueltos uno a uno, disponibles en cajas de 12, 24 y 36 chocolates.',
        tags: ['Praliné', 'Pintado a mano', '12 · 24 · 36'],
      },
      {
        id: 'pralines',
        name: 'Pralinés Caseros con Nueces',
        subtitle: 'Hecho en Casa',
        description:
          'Nuestros pralinés caseros a base de nueces: almendras, avellanas y pasas doradas sobre un disco de chocolate blanco, con leche o negro. Se venden en paquete de 4.',
        tags: ['Almendras', 'Avellanas', '5 $ el paquete de 4'],
      },
      {
        id: 'fruits',
        name: 'Chocolates de Fruta',
        subtitle: 'Maracuyá · Lúcuma · Fresa · Baileys',
        description:
          'Bombones con corazón fluido de maracuyá, lúcuma, fresa o Baileys, con cáscara marmoleada pintada a mano. Trabajamos con ingredientes 100 % frescos, sin aromas artificiales.',
        tags: ['Maracuyá', 'Lúcuma', 'Fresa', 'Baileys'],
      },
      {
        id: 'tablettes',
        name: 'Tabletas de Chocolate',
        subtitle: 'Múltiples Sabores',
        description:
          'Nuestras tabletas están disponibles en múltiples sabores: chocolate blanco, chocolate con leche y chocolate negro 70 %, con frutas secas, nueces o cáscaras confitadas.',
        tags: ['Blanco', 'Leche', 'Negro 70 %'],
      },
      {
        id: 'pretzels',
        name: 'Pretzels Bañados en Chocolate',
        subtitle: 'Dulce y Salado',
        description:
          'Pretzels bañados en chocolate con leche y chocolate negro 70 %: una amalgama de crujiente, dulce y salado, imposible de parar después del primer bocado.',
        tags: ['Crujiente', 'Dulce-salado', '10 unidades · 13 $'],
      },
      {
        id: 'cakepops',
        name: 'Cake Pops',
        subtitle: 'Dulzura Festiva',
        description:
          'Bocados de bizcocho esponjoso bañados en chocolate brillante y decorados a mano. Surtidos de chocolate y vainilla, vendidos por unidad.',
        tags: ['Surtidos', 'Chocolate y vainilla', '3 $ la unidad'],
      },
    ],
  },
  ingredients: {
    eyebrow: 'Nuestros ingredientes',
    titleLead: 'La calidad, antes',
    titleAccent: 'que todo',
    intro:
      'Un chocolate nunca es mejor que sus ingredientes. Elegimos cada componente por su sabor real, nunca por comodidad.',
    freshNote: 'Trabajamos con ingredientes 100 % frescos.',
    items: [
      {
        title: 'Pastillas de cacao Cacao Barry',
        text:
          'Trabajamos exclusivamente con las pastillas de cobertura Cacao Barry, una referencia francesa reconocida por la pureza de sus habas y la finura de su fluidez al templar.',
      },
      {
        title: 'Alto porcentaje de cacao',
        text:
          'Nuestros chocolates privilegian un alto porcentaje de cacao: menos azúcar, más sabor real y un perfil aromático franco.',
      },
      {
        title: 'Frutas, nueces y mantequilla pura',
        text:
          'Almendras, avellanas, pecanas, arándanos, frutas frescas y mantequilla pura — sin aromas artificiales ni sustitutos de grasa.',
      },
    ],
  },
  giftCard: {
    eyebrow: 'Tarjeta regalo',
    titleLead: 'Regala',
    titleAccent: 'dulzura',
    intro:
      '¿No sabes qué elegir? Regala una tarjeta Les Artisans Sucrés, válida en todas nuestras creaciones, tanto en recogida como en entrega.',
    amountsLabel: 'Montos disponibles',
    cta: 'Pedir una tarjeta regalo',
    note:
      'Las tarjetas se envían por correo electrónico y no caducan. Escríbenos por mensaje privado o por correo para personalizarla.',
  },
  orderInfo: {
    eyebrow: 'Cómo pedir',
    titleLead: 'Frescos, hechos',
    titleAccent: 'sobre pedido',
    intro:
      'No guardamos stock: cada caja se prepara especialmente para ti después de recibir tu pedido.',
    cards: [
      {
        title: 'Sobre pedido · 3 días de anticipación',
        text:
          'Todos nuestros productos se hacen sobre pedido. Considera un plazo mínimo de 3 días antes de la fecha deseada para que podamos prepararlo todo a mano.',
      },
      {
        title: 'Pedido mínimo de 50 $',
        text:
          'Se requiere un monto mínimo de 50 $ para todo pedido, tanto en recogida como en entrega.',
      },
      {
        title: 'Pedidos por DM',
        text:
          'Para eventos y regalos corporativos, escríbenos directamente por mensaje privado en Instagram, Facebook o TikTok.',
      },
    ],
    pickupTitle: 'Recogida en Chambly',
    deliveryTitle: 'Entrega',
    deliveryNote:
      'El costo de entrega se calcula según la distancia. Contáctanos para conocer la tarifa exacta.',
    dmTitle: 'Pedidos por mensaje privado',
    dmText:
      'Eventos, bodas y regalos corporativos: escríbenos por DM y preparamos tu proyecto a medida.',
  },
  recipes: {
    eyebrow: 'Nuestro taller en tu casa',
    titleLead: 'Recetas',
    titleAccent: 'Deliciosas',
    intro:
      'Algunas de nuestras recetas favoritas para hacer en familia. Tómate tu tiempo: la paciencia es el primer ingrediente de la artesanía.',
    ingredientsLabel: 'Ingredientes',
    stepsLabel: 'Preparación',
    items: [
      {
        id: 'dulce',
        title: 'Dulce de Leche Casero',
        time: '2 h 30',
        yield: 'unos 400 g',
        description:
          'El corazón de nuestros alfajores. Un dulce de leche lento, cremoso y profundamente aromático.',
        ingredients: [
          '1 L de leche entera',
          '300 g de azúcar',
          '1 vaina de vainilla abierta',
          '1 pizca de bicarbonato de sodio',
        ],
        steps: [
          'Lleva la leche, el azúcar y la vainilla a fuego suave en una olla de fondo grueso.',
          'Añade el bicarbonato fuera del fuego y vuelve a poner a fuego bajo.',
          'Deja reducir 2 horas removiendo con regularidad, hasta obtener un tono ámbar.',
          'Retira la vainilla, deja templar y conserva en el refrigerador hasta 2 semanas.',
        ],
      },
      {
        id: 'alfajores-maison',
        title: 'Alfajores de Maicena',
        time: '1 h 15',
        yield: '12 alfajores',
        description:
          'Galletas ultra suaves que se deshacen en la boca, rellenas de dulce de leche.',
        ingredients: [
          '300 g de maicena',
          '150 g de harina',
          '200 g de mantequilla sin sal a temperatura ambiente',
          '100 g de azúcar glas',
          '3 yemas de huevo',
          'La cáscara de un limón',
          'Dulce de leche y coco rallado',
        ],
        steps: [
          'Bate la mantequilla con el azúcar glas, luego incorpora las yemas y la cáscara.',
          'Añade la maicena y la harina tamizadas, sin trabajar demasiado la masa.',
          'Extiende a 1 cm, corta discos y refrigera 30 minutos.',
          'Hornea 10 a 12 minutos a 170 °C: las galletas deben quedar pálidas.',
          'Rellena generosamente con dulce de leche y pasa los bordes por el coco.',
        ],
      },
      {
        id: 'ganache',
        title: 'Ganache Grand Cru 70 %',
        time: '20 min',
        yield: '20 trufas',
        description:
          'Tres ingredientes, una textura sedosa. Poco azúcar, mucho cacao.',
        ingredients: [
          '200 g de chocolate negro 70 %',
          '150 ml de crema 35 %',
          '30 g de mantequilla sin sal',
          'Cacao en polvo para rebozar',
        ],
        steps: [
          'Pica finamente el chocolate y colócalo en un bol.',
          'Calienta la crema hasta el primer hervor y viértela en tres veces sobre el chocolate.',
          'Mezcla desde el centro hacia afuera y luego incorpora la mantequilla.',
          'Refrigera 3 horas, forma bolitas y pásalas por el cacao.',
        ],
      },
      {
        id: 'cakepops',
        title: 'Cake Pops de Chocolate',
        time: '1 h + reposo',
        yield: '18 cake pops',
        description:
          'Bocados esponjosos bañados en chocolate, para decorar a tu gusto.',
        ingredients: [
          '250 g de bizcocho de chocolate desmenuzado',
          '80 g de ganache o queso crema',
          '300 g de chocolate de cobertura',
          'Palitos para cake pops',
          'Decoración: oro comestible, perlas, chocolate rosado',
        ],
        steps: [
          'Mezcla el bizcocho desmenuzado con la ganache hasta obtener una masa homogénea.',
          'Forma bolitas de 30 g y refrigera 1 hora.',
          'Moja la punta del palito en chocolate fundido y clávalo en cada bolita.',
          'Baña por completo en chocolate templado y deja escurrir el exceso.',
          'Decora de inmediato y deja cristalizar en vertical.',
        ],
      },
    ],
  },
  events: {
    eyebrow: 'Corporativo y Eventos',
    titleLead: 'Dulces para tus',
    titleAccent: 'grandes ocasiones',
    intro:
      'Hacemos pedidos a medida para empresas y eventos: bodas, bautizos, cumpleaños, agradecimientos a clientes y regalos para empleados. Pide directamente por mensaje privado.',
    offerings: [
      {
        title: 'Regalos corporativos',
        text:
          'Cajas elegantes para tus clientes y equipos, con la posibilidad de personalizar el empaque y añadir tu tarjeta o tu logo.',
      },
      {
        title: 'Bodas y celebraciones',
        text:
          'Recuerdos para los invitados, mesas de dulces, cake pops decorados y cajas de agradecimiento a juego con tu paleta.',
      },
      {
        title: 'Grandes cantidades',
        text:
          'Alfajores, chocolates y cake pops en volumen, con un calendario acordado de antemano para garantizar una frescura perfecta.',
      },
      {
        title: 'Sabores personalizados',
        text:
          'Desarrollamos contigo rellenos y coberturas a medida para crear un dulce único a tu imagen.',
      },
    ],
    ctaTitle: 'Hablemos de tu proyecto',
    ctaText:
      'Escríbenos por mensaje privado o por teléfono con tus fechas, cantidades e ideas. Considera un plazo mínimo de 3 días y un pedido mínimo de 50 $.',
    cta: 'Solicitar una cotización',
    dmCta: 'Pedir por DM',
  },
  contact: {
    eyebrow: 'Contacto',
    titleLead: 'Hablemos de',
    titleAccent: 'dulzura',
    intro:
      '¿Una pregunta, un pedido especial, un proyecto de evento? Escríbenos, llámanos o envíanos un mensaje privado.',
    pickupLabel: 'Recogida',
    deliveryLabel: 'Entrega',
    phoneLabel: 'Teléfono',
    emailLabel: 'Correo',
    ordersLabel: 'Pedidos',
    ordersValue: 'Sobre pedido · 3 días de anticipación · Mínimo 50 $',
    followTitle: 'Síguenos',
    form: {
      title: 'Envíanos un mensaje',
      name: 'Nombre',
      email: 'Correo',
      phone: 'Teléfono',
      message: 'Mensaje',
      messagePlaceholder:
        'Cuéntanos qué te apetece, la cantidad y la fecha deseada…',
      send: 'Enviar',
      note: 'Normalmente respondemos dentro de 24 horas.',
    },
  },
  cart: {
    eyebrow: 'Tu pedido',
    titleLead: 'Tu',
    titleAccent: 'Carrito',
    empty: 'Tu carrito está vacío por ahora.',
    emptyCta: 'Ver nuestras creaciones',
    quantity: 'Cantidad',
    savedTitle: 'Guardados para después',
    savedEmpty: 'Ningún producto guardado por ahora.',
    moveToCart: 'Añadir al carrito',
    remove: 'Quitar',
    subtotal: 'Subtotal',
    notice:
      'Todos nuestros productos se hacen sobre pedido: considera 3 días de anticipación.',
    deliveryNote:
      'Recogida en Chambly, o entrega en Brossard, Longueuil, Candiac, Saint-Hubert, Saint-Jean-sur-Richelieu y Carignan — costo según la distancia.',
    minimumWarning:
      'Pedido mínimo de 50 $ — añade {amount} $ más para finalizar.',
    minimumMet: 'Pedido mínimo alcanzado.',
    checkout: 'Pagar ahora',
    securePayment:
      'Pago seguro procesado por Shopify. Serás redirigido a la caja para pagar con tarjeta, Apple Pay o Google Pay.',
    paymentMethodsLabel: 'Medios de pago aceptados',
    orderByDm: 'Pedir por DM',
    continueShopping: 'Seguir comprando',
    each: 'cada uno',
  },
  refund: {
    title: 'Política de reembolso',
    paragraphs: [
      'Todo cambio de opinión respecto al pedido conlleva la pérdida directa del producto.',
      'Por eso, una vez validado tu pedido, no es posible cancelarlo ni devolverlo.',
    ],
  },
  footer: {
    tagline:
      'El arte del cacao, hecho a mano. Recogida en Chambly o entrega en la Rive-Sud.',
    contactTitle: 'Contacto',
    navigationTitle: 'Navegación',
    legalTitle: 'Información',
    rights: 'Todos los derechos reservados.',
    refundLink: 'Política de reembolso',
  },
}
